const Meta = Class(
	/**
	 * @lends {Meta#}
	 */
	{
		__construct(url) {
			this.tags = {
				title: this.getTag('web.og.default.title') || 'Roadgames',
				description: this.getTag('web.og.default.description'),
				ogImage: D.URL + 'assets/images/og.png'
			};
			url = url.replace(/^\/+|\/+$/g, '')
			let urlParts = url.split('/', 2);
			let lang = urlParts[0];
			if (in_array(lang, D.LANGS)) {
				urlParts.shift();
			}
			url = urlParts.join('/');
			urlParts = url.split('?', 2);
			url = urlParts[0];
			urlParts = url.split('/');
			let section = urlParts[0]
			let tags = [
				'title',
				'ogTitle',
				'description',
				'ogDescription'
			];
			tags.forEach(tag => {
				let key = 'web.og.' + section + '.' + tag;
				let value = this.getTag(key);
				if (!value) {
					return;
				}
				this.tags[tag] = value;
			});
		},

		getTag(key) {
			if (!D.OG[D.LANG]) {
				return '';
			}
			if (!D.OG[D.LANG][key]) {
				return '';
			}
			return D.OG[D.LANG][key];
		},

		getTitle() {
			return this.tags.title;
		},

		getOgTitle() {
			return this.tags.ogTitle || this.tags.title;
		},

		getDescription() {
			return this.tags.description;
		},

		getOgDescription() {
			return this.tags.ogDescription || this.tags.description;
		},

		getOgImage() {
			return this.tags.ogImage;
		}
	}
);